import { Fragment, memo } from "react";
import COLORS from "../../theme/Colors";
import { Container } from "./styles/TextFieldStyles";
import InputMask from "react-input-mask";
import { FieldTitle, Row, StyledTextInput } from "../../theme/Styles";
import CircularProgress from "@mui/material/CircularProgress";
import { removeGuionFromString } from "../../utilities/functions/StringUtil";
import { useState } from "react";
import { IconButton, InputAdornment } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

function TextField({
    id,
    title,
    placeholder,
    value,
    onChange,
    onBlur,
    type,
    error,
    mask,
    unMaskedValue,
    useMaskPresets,
    required,
    multiline,
    minLength,
    maxLength,
    max,
    min,
    disabled,
    isLoading,
    endAdornment,
    helperText = " ",
    minRows = 2,
}) {
    const [showPassword, setShowPassword] = useState(false);

    const handleClickShowPassword = () => setShowPassword((show) => !show);
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const isPasswordType = type === "password";
    const currentType = isPasswordType ? (showPassword ? "text" : "password") : type;

    const passwordEndAdornment = isPasswordType ? (
        <InputAdornment position="end">
            <IconButton
                aria-label="toggle password visibility"
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
                edge="end"
                size="small"
            >
                {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
            </IconButton>
        </InputAdornment>
    ) : null;
    const removeTextFromInputMaskValue = (value) => {
        /*  let NewValue = value.replace(/[^0-9\.]+/g, '');
        return NewValue; */
        let NewValue = removeGuionFromString(value).toUpperCase();
        return NewValue;
    };

    const maskPresets = {
        phone: "(999)-999-9999",
        identification: "999-9999999-9",
        passport: "*",
        rnc: "9-99-99999-9",
        "solo numero": "999999999999999999999999999",
        mascaraRut: "aa-*aaa-9999-99999"
    };

    return (
        <div>
            <Row style={{ marginBottom: "4px" }}>
                <FieldTitle>{title} </FieldTitle>
                <div style={{ width: "5px" }} />
                {required ? (
                    <Fragment>
                        <FieldTitle style={{ color: COLORS.red }}>*</FieldTitle>
                    </Fragment>
                ) : null}
            </Row>

            {mask ? (
                <InputMask
                    id={id}
                    mask={useMaskPresets ? maskPresets[mask] || maskPresets["passport"] : mask}
                    maskChar={null}
                    value={value}
                    disabled={disabled}
                    onBlur={
                        unMaskedValue
                            ? (e) => {
                                  onBlur &&
                                      onBlur({
                                          target: {
                                              id: e.target.id,
                                              value: removeTextFromInputMaskValue(e.target.value),
                                          },
                                      });
                              }
                            : onBlur
                    }
                    onChange={
                        unMaskedValue
                            ? (e) => {
                                  onChange({
                                      target: {
                                          id: e.target.id,
                                          value: removeTextFromInputMaskValue(e.target.value),
                                      },
                                  });
                              }
                            : onChange
                    }
                >
                    {(inputProps) => (
                        <StyledTextInput
                            {...inputProps}
                            disabled={disabled}
                            fullWidth
                            variant="outlined"
                            placeholder={placeholder}
                            type={currentType}
                            helperText={helperText}
                            FormHelperTextProps={{ sx: { fontSize: "0.8rem", marginTop: error ? "2px" : "0px", minHeight: error ? "16px" : "0px" } }}
                            error={error}
                            InputProps={{
                                endAdornment: isLoading ? (
                                    <CircularProgress size="1em" />
                                ) : passwordEndAdornment ? (
                                    passwordEndAdornment
                                ) : endAdornment !== undefined ? (
                                    endAdornment
                                ) : null,
                            }}
                        />
                    )}
                </InputMask>
            ) : (
                <StyledTextInput
                    fullWidth
                    disabled={disabled}
                    multiline={multiline}
                    id={id}
                    placeholder={placeholder}
                    value={value}
                    onBlur={onBlur}
                    onChange={onChange}
                    type={currentType}
                    helperText={helperText}
                    FormHelperTextProps={{ sx: { fontSize: "0.8rem", marginTop: error ? "2px" : "0px", minHeight: error ? "16px" : "0px" } }}
                    error={error}
                    minRows={minRows}
                    inputProps={{
                        maxLength: maxLength,
                        minLength: minLength,
                        max: max,
                        min: min,
                    }}
                    InputProps={{
                        endAdornment: isLoading ? (
                            <CircularProgress size="1em" />
                        ) : passwordEndAdornment ? (
                            passwordEndAdornment
                        ) : endAdornment !== undefined ? (
                            endAdornment
                        ) : null,
                    }}
                />
            )}
        </div>
    );
}

export default memo(TextField);
